import React from 'react'
import { footerVariants } from '@web/modules/message-preview/styles'
import { ChatSource } from '@repo/types'

interface FooterProps {
  text: string
  source: ChatSource
}

const { container } = footerVariants()

const Footer = ({ text, source }: FooterProps) => <p className={container({ source })}>{text}</p>

export default Footer
